import { EMOJI_MULTIPLIER } from '../types';

export const EMOJI_COLLECTIONS = [
  {
    id: 'joy',
    label: 'Joy',
    icon: '✨',
    emojis: ['😀', '😄', '😁', '😊', '😉', '😍', '🥰', '😎', '🤩', '🥳', '🤗', '🤓'],
  },
  {
    id: 'creatures',
    label: 'Creatures',
    icon: '🌈',
    emojis: ['😺', '🦊', '🐼', '🐨', '🐸', '🦄', '🐙', '🦋', '🐝', '🐬', '🦜', '🐲'],
  },
  {
    id: 'future',
    label: 'Future',
    icon: '🚀',
    emojis: ['🤖', '👽', '🛸', '🚀', '🪐', '🌙', '⭐', '⚡', '🔮', '💫', '🌌', '🧬'],
  },
] as const;

// A deliberately upbeat fallback set. User-selected emoji are always preserved.
export const HAPPY_USER_EMOJIS = EMOJI_COLLECTIONS.flatMap((collection) => [...collection.emojis]);

export function getUserEmoji(user: { id?: number; avatarEmoji?: string | null }): string {
  if (user.avatarEmoji?.trim()) return user.avatarEmoji;
  if (!user.id) return '🙂';

  const emojiIndex = (user.id * EMOJI_MULTIPLIER) % HAPPY_USER_EMOJIS.length;
  return HAPPY_USER_EMOJIS[emojiIndex];
}
